import globalTheme from '../global'

const Slider = {
	MuiSlider: {
		styleOverrides: {
			root: {
				height: '3px',
				borderRadius: '4px',
				marginBottom: 0,
				'&.Mui-disabled': {
					color: globalTheme.palette.grey.light,
				},
			},
			thumb: {
				width: 24,
				height: 24,
				'&::after': {
					display: 'none',
				},
				'&::before': {
					display: 'none',
				},
				'&:hover': {
					backgroundColor: globalTheme.palette.slider.hover,
					boxShadow: '0px 0px 0px 0',
				},
				'&:focus': {
					backgroundColor: globalTheme.palette.slider.focus,
				},
				'&:active': {
					backgroundColor: globalTheme.palette.slider.active,
				},
				'&.Mui-focusVisible': {
					boxShadow: '0px 0px 0px 0',
					backgroundColor: globalTheme.palette.slider.focus,
				},
				'&.Mui-active': {
					backgroundColor: globalTheme.palette.slider.active,
				},
			},
			rail: {
				backgroundColor: globalTheme.palette.grey.light,
				opacity: 1,
			},
			markLabel: {
				color: globalTheme.palette.primary.main,
			},
			mark: {
				display: 'none',
			},
		},
	},
}

export default Slider
